import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {ExperienceBadge, ExperienceCardDto} from 'src/app/models/ExperiencesModels';

interface BadgeDisplay {
    label: string;
    icon: string;
}

const BADGE_DISPLAYS: Record<ExperienceBadge, BadgeDisplay> = {
    [ExperienceBadge.SpecialOffer]: {label: 'Special offer', icon: 'ph ph-tag'},
    [ExperienceBadge.LikelyToSellOut]: {label: 'Likely to sell out', icon: 'ph ph-fire'}
};

@Component({
    selector: 'viator-card',
    templateUrl: './viator-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {class: 'block w-full'}
})
export class ViatorCardComponent {
    @Input({required: true}) experience!: ExperienceCardDto;
    @Input({required: true}) hasMemberPricing!: boolean;
    @Input() cardStyleClass = '';
    @Input() showDiscountPill = false;
    @Output() selected = new EventEmitter<ExperienceCardDto>();

    readonly badgeDisplays = BADGE_DISPLAYS;
}
